import { useMutation } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';

export interface CancelParentsBulkImportParams {
  jobId: string;
}

export interface CancelParentsBulkImportResponse {
  success: boolean;
  message: string;
}

export const cancelParentsBulkImportAPI = async (
  params: CancelParentsBulkImportParams,
) => {
  const response = await baseAPI.post<CancelParentsBulkImportResponse>(
    `/parents/bulk-import-cancel/${params.jobId}`,
  );
  return response.data;
};

export const useCancelParentsBulkImportMutation = () => {
  return useMutation({
    mutationFn: cancelParentsBulkImportAPI,
  });
};
